<template>
  <MProviderPage :provider-code :provider-name />
</template>

<script setup lang="ts">
import { useCasinoProviderPage } from '@st/casino/composables/useCasinoProviderPage'

definePageMeta({
  layout: 'mobile',
})

const { pageTitle, providerCode, providerName } = useCasinoProviderPage()

useSeoData('casino-provider', { casinoProviderPageTitle: pageTitle })
</script>
